var map = {
	"./about.png": "10b3",
	"./add.png": "2862",
	"./admin.png": "5d5c",
	"./book.png": "cdbf",
	"./break.png": "88c0",
	"./cancel.png": "24c4",
	"./changelog.png": "7544",
	"./chat.png": "6f87",
	"./check.png": "1ecc",
	"./command-attack.png": "8f81",
	"./command-rally.png": "e9ef",
	"./copy.png": "5a0e",
	"./crafting.png": "c0aa",
	"./cursor.png": "e3f6",
	"./defense.png": "6177",
	"./diagonal.png": "af93",
	"./distribution.png": "a70f",
	"./donate.png": "a45b",
	"./dots.png": "64d4",
	"./download.png": "a83f",
	"./editor.png": "6872",
	"./effect.png": "58f0",
	"./elevation.png": "e9e3",
	"./eraser.png": "7aeb",
	"./exit.png": "5159",
	"./export.png": "fbbb",
	"./eye-off.png": "4bae",
	"./eye.png": "a301",
	"./fdroid.png": "03c7",
	"./file-image.png": "0978",
	"./file-text.png": "5ffa",
	"./file.png": "cd24",
	"./fill.png": "89bd",
	"./flip.png": "b301",
	"./folder-parent.png": "6210",
	"./folder.png": "d454",
	"./grid.png": "4e85",
	"./hammer.png": "51af",
	"./home.png": "d50d",
	"./host.png": "898e",
	"./info.png": "3c34",
	"./itchio.png": "8b52",
	"./item.png": "36cb",
	"./line.png": "448f",
	"./link.png": "aebd",
	"./liquid-consume.png": "514a",
	"./liquid.png": "4256",
	"./load-image.png": "8d8a",
	"./load.png": "f068",
	"./loading.png": "9306",
	"./lock-open.png": "d545",
	"./lock.png": "33d8",
	"./map.png": "66d2",
	"./menu.png": "56b4",
	"./missing.png": "29bd",
	"./mode-attack.png": "89d5",
	"./mode-pvp.png": "1eef",
	"./mode-survival.png": "b366",
	"./none.png": "c219",
	"./paste.png": "a888",
	"./pause.png": "18cd",
	"./pencil.png": "4b7e",
	"./pick.png": "61ef",
	"./planet.png": "b248",
	"./play-2.png": "fac7",
	"./play.png": "070a",
	"./players.png": "d439",
	"./power.png": "5d1c",
	"./production.png": "b58f",
	"./quit.png": "9d26",
	"./redo.png": "d0e7",
	"./refresh.png": "1fd6",
	"./rename.png": "8b41",
	"./resize.png": "aff7",
	"./rotate-arrow.png": "8aa8",
	"./rotate-left.png": "2deb",
	"./rotate-right.png": "e450",
	"./rotate.png": "7ed7",
	"./save-image.png": "eb15",
	"./save.png": "dde0",
	"./search.png": "13b1",
	"./settings.png": "6a88",
	"./spray.png": "fa6c",
	"./terrain.png": "50aa",
	"./tools.png": "cd55",
	"./trash-16.png": "aa0f",
	"./trash.png": "44ee",
	"./tree.png": "ac48",
	"./turret.png": "71b5",
	"./tutorial.png": "432d",
	"./undo.png": "fbe6",
	"./units.png": "7f52",
	"./upload.png": "94d8"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7644";